module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "progress": _vm.progress
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('show') : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('meteor') : _vm._e(), _vm._v(" "), _c('background-audio'), _vm._v(" "), _c('footer', {
    staticStyle: {
      "position": "fixed",
      "z-index": "100",
      "bottom": "0",
      "width": "100%",
      "padding": "4px",
      "color": "rgba(255,255,255,.7)",
      "text-align": "center"
    }
  }, [_vm._v("ygjack414@hotmail.com")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-ebcd776c"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 207
// module chunks = 1